import * as React from 'react';
import { AnyAction, Dispatch } from 'redux';

import { GetAllEventActionsRequest } from '../api/definitions/getAllEventActionsRequest';
import * as EntityNormalizers from '../api/normalizers/entityNormalizers';
import * as EventActionNormalizers from '../api/normalizers/eventActionNormalizers';
import { DataRequestActionTypes, InternalActionTypes } from '../constants/actionTypes';

import { RequestAction } from './allActions';
import { runApiRequest, throttleRequests } from './saga/sagaActions';

export interface EventActionsLoadedAction extends AnyAction {
  type: InternalActionTypes.EventActionsLoaded;
  result: EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>;
  eventId: string;
}

export interface RequestAllEventActionsAction extends RequestAction {
  type: DataRequestActionTypes.AllEventActionsRequested;
  eventId: string;
}

function createEventActionsLoadedAction(
  eventId: string,
  result: EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>,
): EventActionsLoadedAction {
  return {
    eventId,
    result,
    type: InternalActionTypes.EventActionsLoaded,
  };
}

export function createAllEventActionsRequestedAction(
  eventId: string,
  component: React.Component,
  dispatch: Dispatch,
): RequestAllEventActionsAction {
  return {
    dispatch,
    eventId,
    requestingComponent: component,
    type: DataRequestActionTypes.AllEventActionsRequested,
  };
}

function* loadEventActions(action: RequestAllEventActionsAction) {
  const request = new GetAllEventActionsRequest(action.eventId, action.requestingComponent, action.dispatch);
  yield runApiRequest(
    request,
    // @ts-ignore
    (result: EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>) =>
      createEventActionsLoadedAction(action.eventId, result),
  );
}

export function* loadEventActionsSaga() {
  yield throttleRequests(
    DataRequestActionTypes.AllEventActionsRequested,
    loadEventActions,
    (a: RequestAllEventActionsAction) => a.eventId,
  );
}
